import { useActiveFtu } from '../hooks/useActiveFtu'
import { useFtuCompletionSync } from '../hooks/useFtuCompletionSync'

import { useAppSelector } from '@/redux/hooks'
import { selectMe } from '@/redux/me/meSlice'

import { FTU_REGISTRY } from '../registry/ftus'
import { FtuTour } from './FtuTour'

/**
 * Globally-mounted entry point for the first-time-use engine (rendered in
 * _app.tsx). Picks the single active FTU and renders its tour, subject to the
 * global gates: a logged-in user whose backend completions have been synced,
 * and no active emergency call.
 */
export const FtuManager = () => {
  const me = useAppSelector(selectMe)
  const { isSynced } = useFtuCompletionSync(me?.id)
  const isEmergencyCallOpen = useAppSelector(
    (state) => state.ui.emergencyCall?.isOpen ?? false
  )
  const activeFtu = useActiveFtu(FTU_REGISTRY)

  if (!me?.id || !isSynced || isEmergencyCallOpen || !activeFtu) {
    return null
  }

  return <FtuTour ftu={activeFtu} key={activeFtu.id} />
}
